import { format, parse, parseISO, isValid } from 'date-fns';
import StringHelper from './string-helper';

// Converte tokens de formato do moment (ex.: DD/MM/YYYY) para date-fns
// (dd/MM/yyyy): D→d (dia), Y→y (ano); M (mês) é igual nas duas libs.
export const toDateFnsToken = momentToken =>
  momentToken.replace(/D/g, 'd').replace(/Y/g, 'y');

// Timezone assumida quando a propriedade não informa a sua — evita cair no
// fuso do navegador do hóspede, que pode ser outro.
export const DEFAULT_TIMEZONE = 'America/Sao_Paulo';

// Hora atual (0–23) na timezone informada (ex.: America/Sao_Paulo). Se a
// timezone vier vazia ou inválida, cai para a hora local do navegador.
export const getCurrentHourInTimeZone = timeZone => {
  const now = new Date();

  if (StringHelper.isNotEmpty(timeZone)) {
    try {
      const hour = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hour: 'numeric',
        hour12: false,
      }).format(now);
      const parsed = parseInt(hour, 10);

      if (!Number.isNaN(parsed)) {
        // alguns engines devolvem "24" à meia-noite
        return parsed % 24;
      }
    } catch (e) {
      // timezone inválida: usa a hora local abaixo
    }
  }

  return now.getHours();
};

const DateTimeHelper = {
  getCurrentHourInTimeZone,

  isUnformattedDate: date => {
    return (
      StringHelper.isNotEmpty(date) &&
      new RegExp(/^(\d{4})-(\d{2})-(\d{2})$/).test(date.toString())
    );
  },

  toDisplay: (date, t) => {
    if (DateTimeHelper.isUnformattedDate(date)) {
      return format(parseISO(date), toDateFnsToken(t('calendar.dateFormat')));
    }

    return '';
  },

  formatDate: date => {
    if (!date) {
      return date;
    }
    // tenta parsear nos formatos DD-MM-YYYY / DD/MM/YYYY; se válido, normaliza
    // para YYYY-MM-DD; senão devolve o valor original (mesmo comportamento que
    // antes, com moment).
    const parsed = ['dd-MM-yyyy', 'dd/MM/yyyy']
      .map(fmt => parse(date.toString(), fmt, new Date()))
      .find(d => isValid(d));

    return parsed ? format(parsed, 'yyyy-MM-dd') : date;
  },
};

export default DateTimeHelper;
